import { useState } from "react";
import { toast } from "sonner";
import { CalendarDays, FileText, Mail, MessageSquare, Phone, ArrowRightLeft, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ACTIVITY_TYPES, stageLabel } from "./crmConst";

const ICON = { note: MessageSquare, appel: Phone, email: Mail, rdv: CalendarDays, etape: ArrowRightLeft, devis: FileText };
const SYS_LABEL = { etape: "Changement d'étape", devis: "Devis PDF" };
const fmtDT = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

export const ActivityLog = ({ clientId, activities, reload }) => {
  const [type, setType] = useState("note");
  const [content, setContent] = useState("");
  const [date, setDate] = useState("");
  const add = async () => {
    if (!content.trim()) return;
    await api.post(`/crm/clients/${clientId}/activities`, { type, content, date: date ? new Date(date).toISOString() : null });
    setContent(""); setDate(""); toast.success("Échange ajouté"); reload();
  };
  const del = async (id) => { await api.delete(`/crm/activities/${id}`); reload(); };
  return (
    <div className="space-y-4" data-testid="crm-activities">
      <div className="rounded-lg border border-border p-3 space-y-2">
        <div className="flex gap-2">
          <Select value={type} onValueChange={setType}>
            <SelectTrigger className="w-32" data-testid="crm-activity-type"><SelectValue /></SelectTrigger>
            <SelectContent>{ACTIVITY_TYPES.map((t) => <SelectItem key={t.v} value={t.v}>{t.label}</SelectItem>)}</SelectContent>
          </Select>
          <Input type="datetime-local" value={date} onChange={(e) => setDate(e.target.value)} className="flex-1" title="Date (par défaut : maintenant)" data-testid="crm-activity-date" />
        </div>
        <Textarea rows={2} placeholder="Compte-rendu, contenu de l'email, objet du RDV…" value={content} onChange={(e) => setContent(e.target.value)} data-testid="crm-activity-content" />
        <Button size="sm" className="bg-genis hover:bg-genis-dark text-white" onClick={add} disabled={!content.trim()} data-testid="crm-activity-add">Ajouter à l'historique</Button>
      </div>
      <ol className="relative border-l border-border ml-2 space-y-4">
        {activities.map((a) => {
          const Icon = ICON[a.type] || MessageSquare;
          const [from, to] = a.type === "etape" ? a.content.split("→") : [];
          return (
            <li key={a.id} className="ml-5 group" data-testid={`crm-activity-${a.id}`}>
              <span className="absolute -left-3 grid h-6 w-6 place-items-center rounded-full bg-genis/10 text-genis ring-4 ring-background"><Icon className="h-3 w-3" /></span>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span className="font-semibold text-foreground">{SYS_LABEL[a.type] || ACTIVITY_TYPES.find((t) => t.v === a.type)?.label}</span>
                <span>{fmtDT(a.date)}</span>{a.author && <span>· {a.author}</span>}
                {!SYS_LABEL[a.type] && (
                  <button onClick={() => del(a.id)} className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-red-600" data-testid={`crm-activity-del-${a.id}`}><Trash2 className="h-3.5 w-3.5" /></button>
                )}
              </div>
              <p className="text-sm mt-0.5 whitespace-pre-wrap">{a.type === "etape" ? `${stageLabel(from)} → ${stageLabel(to)}` : a.content}</p>
            </li>
          );
        })}
        {!activities.length && <li className="ml-5 text-sm text-muted-foreground">Aucun échange pour l'instant.</li>}
      </ol>
    </div>
  );
};
